export default __webpack_public_path__ + "static/media/khan_academy.ee3f26b4.svg";